import { useAppSelector } from '@hooks';
import { getUser } from '@store/user/user.slice';

export const useAuth = () => {
  const user = useAppSelector(getUser);
  return {
    ...user,
  };
};
